module.exports = __webpack_public_path__ + "img/et.51ff2c23.svg";